import { useMemo } from "react";

export const useDroneUIState = ({
  title,
  availableDrone = [],
  unavailableDrone = [],
  availableDoors = [],
  drone_nests = [],
  unAssignDoorsList = [],
  unAssignDronesList = [],
  droneNest = null,
}) => {
  /* ---------------- DRONE NEST ---------------- */
  const drone_nest = useMemo(() => {
    if (!drone_nests.length || !droneNest) return null;

    return drone_nests.find((e) => e.id === droneNest) || null;
  }, [drone_nests, droneNest]);

  /* ---------------- TITLE ---------------- */
  const titleUI = useMemo(() => {
    if (title === "drone_nest") return drone_nest?.name || "";

    if (title === "Available" || title === "Unavailable") {
      return `${title} Drones`;
    }

    return title;
  }, [title, drone_nest]);

  /* ---------------- FILTERED ARRAYS ---------------- */

  const availabelDronesArr = useMemo(() => {
    if (title !== "Available" && title !== "drone_nest") return [];

    if (!droneNest) return availableDrone;

    return availableDrone.filter((d) => d.nest_id === droneNest);
  }, [availableDrone, droneNest, title]);

  const unavailabelDronesArr = useMemo(() => {
    if (title !== "Unavailable" && title !== "drone_nest") return [];

    if (!droneNest) return unavailableDrone;

    return unavailableDrone.filter((d) => d.nest_id === droneNest);
  }, [unavailableDrone, droneNest, title]);

  const availableDoorsArr = useMemo(() => {
    if (title !== "Doors" && title !== "drone_nest") return [];

    if (!droneNest) return availableDoors;

    return availableDoors.filter((d) => d.id === droneNest);
  }, [availableDoors, droneNest, title]);

  const unAssignDoorsArr = useMemo(() => {
    if (title !== "Unassigned Doors") return [];

    return unAssignDoorsList;
  }, [unAssignDoorsList, title]);
  const unAssignDronesArr = useMemo(() => {
    if (title !== "Unassigned Drones") return [];

    return unAssignDronesList;
  }, [unAssignDronesList, title]);

  /* ---------------- HAS DATA ---------------- */
  const isData = useMemo(() => {
    return (
      availabelDronesArr.length > 0 ||
      unavailabelDronesArr.length > 0 ||
      unAssignDronesArr.length > 0 ||
      unAssignDoorsArr.length > 0 ||
      availableDoorsArr.length > 0
    );
  }, [availabelDronesArr, unavailabelDronesArr, availableDoorsArr,unAssignDronesArr,unAssignDoorsArr]);

  /* ---------------- EMPTY STATE ---------------- */
  const droneBoxProps = useMemo(() => {
    const base = {
      showAvailableEmpty: false,
      showUnAssignedDronesEmpty: false,
      showDoorsEmpty: false,
      showUnAssignedDoorsEmpty: false,
      showUnavailableEmpty: false,
    };

    if (title === "Available") {
      return { ...base, showAvailableEmpty: true };
    }

    if (title === "Unavailable") {
      return { ...base, showUnavailableEmpty: true };
    }

    if (title === "Doors") {
      return { ...base, showDoorsEmpty: true };
    }
    if (title === "Unassigned Doors") {
      return { ...base, showUnAssignedDoorsEmpty: true };
    }
    if (title === "Unassigned Drones") {
      return { ...base, showUnAssignedDronesEmpty: true };
    }

    if (title === "drone_nest") {
      return {
        ...base,
        showAvailableEmpty: true,
        showUnavailableEmpty: true,
        showDoorsEmpty: true,
        available_drones: availabelDronesArr.length,
        unavailable_drones: unavailabelDronesArr.length,
        available_doors: availableDoorsArr.length,
      };
    }

    return base;
  }, [title, availabelDronesArr, unavailabelDronesArr, availableDoorsArr]);

  return {
    titleUI,
    isData,
    droneBoxProps,
    availabelDronesArr,
    unavailabelDronesArr,
    availableDoorsArr,
    unAssignDoorsArr,
    unAssignDronesArr
  };
};